<template>
<div id="etips" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Video Tutoriales" class="elevation-1 px-5 py-3" >

                    <v-card-text>
                        <v-row>
                            <v-col cols="3" style=" height:auto;   background-color: white;" >

                                <v-navigation-drawer permanent left style="z-index:0 !important; margin-top: -6px; height: 750px; width:350px !important;" >

                                    <br />

                                    <v-list dense class="pt-0 " >

                                        <v-list-group v-for="(grupo, index) in grupos" :key="'grupo'+index" v-show="getItemsGrupo(grupo).length > 0" no-action prepend-icon="menu_book" :value="grupo==grupoActivo" >
                                            <template v-slot:activator>
                                                <v-list-item-title>{{grupo}}</v-list-item-title>
                                            </template>

                                            <v-list-item v-for="(item, index2) in getItemsGrupo(grupo)" :key="index2" @click="cargarOne(item.id_notificaciones_marquee)" :class=" {'#e0e0e0 secondary lighten-1': selected ==item.id_notificaciones_marquee}" >

                                                <v-list-item-content>
                                                    - {{ item.nombre }}
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-group>
                                    </v-list>

                                </v-navigation-drawer>

                            </v-col>

                            <v-col id="contenedor" class="d-flex" style="height:auto; overflow-y:auto;  background-color: white;" >

                                <div id="htmlSource" class="manual" >
                                    <meta charset="utf-8" >
                                            <h1 >{{titulo}}</h1>
                                            <div v-html = "contenido" />
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script lang="en" >
import axios from "axios";

import Vue from 'vue'
import {
    mapMutations,
    mapState
} from 'vuex'

export default {
    data: () => ({
        filteredList: [],
        isAdmin: true,
        grupos: [],
        grupoActivo: "Administración",
        fab: false,
        selected: "",
        URL: "",
        contenido: "",
        titulo:"",
        show_loading: true,
        title_catalogo: "Video Tutoriales",
        columnDefs: null,
        rowData: null,
        show_loading: true,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/admin"
            },
            {
                text: "Video Tutoriales",
                disabled: true,
                to: ""
            }
        ],
        loading: false,
        title: "",
        search: "",

    }),
    computed: mapState({
        superusuario() {
            return this.$local_storage.get("tipo_usuario") == "Super Usuario";
        },
        cliente() {
            return this.$local_storage.get("tipo_usuario") == "Grupo" || this.$local_storage.get("tipo_usuario") == "Cliente";

        },
         es_transportista() {
            return this.$local_storage.get("es_transportista")==1 ;
        },
       
        soloCartaPorte(){
            return (this.$local_storage.get("soloCartaPorte") == 100);
        },
      
    }),
    methods: {
        groupBy: function (key, array ) { 
           return array.reduce(
                (objectsByKeyValue, obj) => ({
                ...objectsByKeyValue,
                [obj[key]]: (objectsByKeyValue[obj[key]] || []).concat(obj)
                }),
                {}
            )
        },
        getMarquees: function () {
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            axios
                .get(this.$hostname + "catalogos/notificaciones_marquee/")
                .then(response => {
                    let avisos = response.data.filter(aviso => aviso.activo == 1 &&  aviso.tipo == 2 );
                    this.filteredList = avisos;
                    var distinct = []
                    for (var i = 0; i < avisos.length; i++){
                        if (  distinct.includes(avisos[i].categoria) == false )
                            distinct.push(avisos[i].categoria)
                    }
                    this.grupos = distinct;
                    if(this.es_transportista || this.soloCartaPorte ){
                             this.grupos = distinct.filter(e => {
                                    return e == "eManifiesto-CCP";
                            });
                        }
                    this.$root.$dialogLoader.hide();
                })
                .catch(error => {
                    console.log("Ocurrió un error al obtener los avisos.");
                    this.$root.$dialogLoader.hide();
                });
        },
        getItemsGrupo: function (idGrupo) {
            let self = this;
            var filtro = [];
          
                filtro = this.filteredList.filter(function (item) {
                    return item.categoria == idGrupo ;
                });
            
            filtro = filtro.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return filtro;
        },
   

       
        cargarOne: function (id) {
           
            this.selected = id;
            let video = this.filteredList.filter(function (item) {
                return item.id_notificaciones_marquee == id ;
            });
           
            this.contenido = video[0].texto;
            this.titulo = video[0].nombre;


        },
       
        
    }, //methods
    mounted: function () {
        this.URL = this.$hostname;
        
        if (this.$local_storage.get("id_cliente") > 0) {
            this.breadcrumbs[0].to = "/home";
        } else {
            this.breadcrumbs[0].to = "/admin";
        }
         if (this.$store.state.carta_porte == 1 || this.$local_storage.get("es_transportista")==1) {
            this.breadcrumbs= [{
                        text: "Inicio",
                        disabled: false,
                        to: "/indext"
                    },
                    {
                        text: "Video Tutoriales",
                        disabled: true,
                        href: ""
                    }
                ]
       }
        this.getMarquees();
        //this.cargarOne(1);
    }
};
</script>

<style scoped>
.global {
    margin-left: 20px;
    height: auto;
    width: auto;
    font-family: Arial, sans-serif;
    font-size: small;
}

.manual {
    margin: 0px;
    padding: 0px;
    height: auto;
    width: auto;
    background: #fff;
    text-align: justify;
    font-family: Arial, sans-serif;
}

h3 {
    font-family: Arial, sans-serif;
    color: navy;
    font-size: x-large;
    font-weight: bold;

}

h4 {
    font-family: Arial, sans-serif;
    font-size: medium;
    font-weight: bold;
    margin-left: 20px;
    font-style: italic;
    color: gray;
}

h5 {
    font-family: Arial, sans-serif;
    font-size: small;
    margin-left: 20px;
    font-weight: bold;
}
</style>
